import React from 'react';
import { TextField, makeStyles } from '@material-ui/core';
import { Autocomplete as MuiAutocomplete } from '@material-ui/lab';
import { matchSorter } from 'match-sorter';

const fuzzyFilter = (options, { inputValue }) =>
    inputValue ? matchSorter(options, inputValue) : options;

const useSelectFilterStyles = makeStyles({
    inputRoot: {
        flexWrap: 'nowrap',
        height: 22,
        backgroundColor: '#fff',
        border: '1px solid #d0d0d0',
        borderRadius: 3,
        fontSize: 12,
        paddingLeft: '6px !important',
        paddingRight: '46px !important',
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
    },
    input: { padding: '0 !important', fontSize: 12 },
    endAdornment: { top: '50%', transform: 'translateY(-50%)' },
    clearIndicator: { padding: 1, '& svg': { fontSize: 14 } },
    popupIndicator: { padding: 1, '& svg': { fontSize: 14 } },
    option: { fontSize: 12, padding: '3px 8px', minHeight: 'unset' },
    paper: { fontSize: 12, minWidth: 160 },
    noOptions: { fontSize: 12, padding: '4px 8px' },
});

export default function AnalyticsSelectFilter({ column }) {
    const { filterValue, setFilter, filterOptions = [] } = column;
    const selected = filterValue?.value ?? null;
    const classes = useSelectFilterStyles();

    return (
        <MuiAutocomplete
            classes={classes}
            options={filterOptions}
            value={selected}
            onChange={(_, newValue) => {
                setFilter(newValue != null ? { value: newValue, operation: '=' } : undefined);
            }}
            filterOptions={fuzzyFilter}
            getOptionLabel={(opt) => String(opt)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="–"
                    InputProps={{ ...params.InputProps, disableUnderline: true }}
                />
            )}
            openOnFocus
            blurOnSelect
            clearOnEscape
            noOptionsText="Nerasta"
            style={{ width: '100%' }}
        />
    );
}
